import { createApp } from "vue";
import { createPinia } from "pinia";
import "./assets/styles/index.css";
import App from "./App.vue";
import router from "./routes/router.js";
import { auth } from "./firebase.js";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faBluesky, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope as faEnvelopeRegular } from "@fortawesome/free-regular-svg-icons";
import { faChevronUp, faChevronDown, faPaw, faCat, faLock } from "@fortawesome/free-solid-svg-icons";
import { faUsers } from "@fortawesome/free-solid-svg-icons";

import {
  faBars,
  faTimes,
  faHome,
  faDollarSign,
  faUser,
  faSignInAlt,
  fas,
} from "@fortawesome/free-solid-svg-icons";

import { onAuthStateChanged } from "firebase/auth";

// Enregistrement du service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('ServiceWorker enregistré avec succès : ', registration.scope);
      })
      .catch(error => {
        console.error('Erreur lors de l\'enregistrement du ServiceWorker : ', error);
      });
  });
}

library.add(
  faBars,
  faTimes,
  faHome,
  faUsers,
  faBluesky,
  faDollarSign,
  faUser,
  faSignInAlt,
  faFacebook,
  faEnvelopeRegular,
  faChevronUp,
  faChevronDown,
  faPaw,
  faCat,
  fas,
);

const pinia = createPinia();
const app = createApp(App);

app.use(router);
app.use(pinia);
app.component("font-awesome-icon", FontAwesomeIcon);

// Monter l'app immédiatement
app.mount("#app");